import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrl: './confirm.component.scss',
    imports: [TranslateModule, ButtonModule, DialogModule]
})
export class ConfirmDialogComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() config: any;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() togglePopupConfirm: EventEmitter<{ visible: boolean; confirm: boolean }> =
    new EventEmitter();

  constructor() {}

  ngOnInit() {}

  confirm(isConfirm: boolean) {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.togglePopupConfirm.emit({ visible: this.visible, confirm: isConfirm });
  }

  toggleVisible(visible: boolean) {
    this.visible = visible;
    this.visibleChange.emit(this.visible);
    this.togglePopupConfirm.emit({ visible, confirm: false });
  }
}
